export default __webpack_public_path__ + "static/media/newsImage2.bc483ca5.png";